import { QuestionType } from '../questions';

export const question1: QuestionType = {
    id: 0,
    type: "generale",
    question: "",
    options: [],
}